import React from "react";

const LoadableTemplateInspect = React.lazy(() => import("./template-inspect"));

export default LoadableTemplateInspect;
